import {
  Box,
  Center,
  chakra,
  Flex,
  Heading,
  HTMLChakraProps,
  Image,
  List,
  ListIcon,
  ListItem,
  Spacer,
  Text
} from '@chakra-ui/react'
import * as React from 'react'
import {filter} from "../components/SectionWrapper";
import MarketingImage from "../assets/img/marketing-team.jpg"
import HeroImage from "../assets/img/hero.jpg"
import {MdCheckCircleOutline} from "react-icons/md";

interface Props extends HTMLChakraProps<"div"> {
  scrollMargin: number,
  wrapperWidth: string | undefined,
}

export const MarketingSection: React.FC<Props> = (props: Props) => {
  const filteredProps = filter(props);
  return <chakra.div
    display={"flex"}
    flexWrap={"wrap"}
    scrollSnapAlign={"start"}
    as={"section"}
    p={0}
    mb={{base: "2em", lg: "4em"}}
    alignItems={'center'}
    {...filteredProps}

  >
    <Flex
      direction={"column"}
      m={0}
      p={0}
      w={"100%"}
    >
      <Box
        m={'0'}
        mb={{base: "4em", md: "12em"}}
        backgroundImage={`url('${HeroImage}')`}
        backgroundSize={"cover"}
        backgroundPosition={'center'}
        backgroundRepeat={"no-repeat"}
      >
        <Center>
          <Box
            bg="white"
            p={{base: "2.5em 2em", md: "5em 4em"}}
            m={{base: "3em 1.5em", md: "12em 6em"}}
            color={"black"}
            maxW={"container.xl"}>
            <Heading
              style={{fontFamily: 'JetBrains Mono'}}
              mb={{base: 6, md: 8}}
            >
              Technisches Know-how trifft kreatives Köpfchen
            </Heading>
            <Text fontSize={"lg"} textAlign={"center"}>
              Wir begleiten Sie auf Ihrem Weg in die digitale Zukunft.
              Von der Strategie und technischen Umsetzung bis hin zur Positionierung am Markt – nur maßgeschneiderte
              Lösungen führen nachhaltig zu Ihrem Erfolg.
            </Text>
          </Box>
        </Center>
      </Box>
      <Box p={{base: "0em 2em", md: "0em 6em"}} m={0}>
        <Flex direction={"column"}>
          <Box p={0}>
            <Heading as={"h2"} style={{fontFamily: 'JetBrains Mono'}} mb={10}>
              Was ist ein Unternehmen ohne Webseite?<br/>
              Was ist eine Webseite ohne Sichtbarkeit?
            </Heading>
          </Box>
          <Flex p={0} m={0} direction={{base: "column", md: "row"}} align={"center"}>
            <Box m={0}>
              <Text fontSize={"lg"}>
                Diese fast schon philosophischen Fragen kann unsere Marketingexpertin beantworten:
              </Text>
              <Text
                fontSize={"lg"}
                p={{base: "1.5em 1em"}}
                m={4}
                borderLeft={"0.25em solid #7AA39F"}
              >
                Egal, ob Friseursalon, Kanzlei oder Einzelhandel – ohne Onlinepräsenz bleibt Erfolg von regionalen
                Faktoren,
                Laufkundschaft und Empfehlungen abhängig. <Text fontWeight={"bold"}>Wer heutzutage nachhaltig sichtbar
                und bekannt bleiben möchte,
                braucht
                eine individuelle Online-Strategie:</Text>
              </Text>
              <List spacing={2} style={{fontFamily: 'JetBrains Mono'}} fontSize={"lg"} mb={4}
                    p={{base: "1em 1.5em", md: "4em 8em",}} bg={"#F1F7F5"}>
                <ListItem><ListIcon as={MdCheckCircleOutline} color='#7AA39F'/>Moderne Webseite oder
                  Onlineshop</ListItem>
                <ListItem><ListIcon as={MdCheckCircleOutline} color='#7AA39F'/>Sichtbarkeit bei Google & Co.</ListItem>
                <ListItem><ListIcon as={MdCheckCircleOutline} color='#7AA39F'/>Reichweite durch Soziale
                  Medien</ListItem>
                <ListItem><ListIcon as={MdCheckCircleOutline} color='#7AA39F'/>Kontakt zu (potentiellen)
                  Kunden</ListItem>
              </List>
              <Text
                fontSize={"lg"}
                p={4}
              >
                Daher bieten wir neben Highlevel Softwareentwicklung und Beratung in Digitalierungsfragen auch die
                Erstellung
                und Verwaltung von Webseiten, Online-Shops und individuelles Online-Marketing an.
              </Text>
            </Box>
            <Image boxSize={"500px"} objectFit={"cover"} src={`${MarketingImage}`}/>
            <Spacer/>
          </Flex>
          <Box p={{base: 5, lg: 6, '2xl': 7}}>

          </Box>
        </Flex>
      </Box>
    </Flex>
  </chakra.div>;
}
